// extracted by mini-css-extract-plugin
module.exports = {"container":"sub-header-item_container__1KYZQ","active":"sub-header-item_active__1yluc"};